var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-loading',{attrs:{"can-cancel":true,"is-full-page":true},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}}),_c('LayoutDefault',[_c('router-view',{on:{"showLoading":_vm.showLoading,"showMessage":_vm.showMessage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }